module.exports = __webpack_public_path__ + "static/media/check.8fedc1c4.svg";